import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { formatCurrency } from "@/components/StatusBadge";

function download(filename, rows) {
  const csv = rows.map((r) => r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export default function Reports() {
  const [client, setClient] = useState([]);
  const [cur, setCur] = useState([]);
  useEffect(() => {
    api.get("/api/reports/client-outstanding").then((r) => setClient(r.data));
    api.get("/api/reports/currency-outstanding").then((r) => setCur(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="text-3xl font-heading font-semibold tracking-tight">Reports</h1>
        <p className="text-sm text-slate-500 mt-1">Business, invoicing and collection reports.</p>
      </div>

      <Card className="border-slate-200 shadow-none p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-heading font-medium">Client-wise Outstanding</div>
          <Button variant="outline" size="sm" data-testid="export-client-csv"
            onClick={() => download("client-outstanding.csv",
              [["Firm", "Currency", "Invoiced", "Received", "Outstanding"],
               ...client.map((c) => [c.firm_name, c.currency, c.invoiced, c.received, c.outstanding])])}>
            Export CSV
          </Button>
        </div>
        <table className="data-table w-full">
          <thead><tr><th>Firm</th><th>Currency</th><th>Invoiced</th><th>Received</th><th>Outstanding</th></tr></thead>
          <tbody>
            {client.map((c) => (
              <tr key={`${c.firm_name}|${c.currency}`}>
                <td className="font-medium">{c.firm_name}</td>
                <td>{c.currency}</td>
                <td>{formatCurrency(c.invoiced, c.currency)}</td>
                <td className="text-emerald-700">{formatCurrency(c.received, c.currency)}</td>
                <td className="text-amber-700">{formatCurrency(c.outstanding, c.currency)}</td>
              </tr>
            ))}
            {client.length === 0 && <tr><td colSpan={5} className="text-center text-slate-500 py-6">No data.</td></tr>}
          </tbody>
        </table>
      </Card>

      <Card className="border-slate-200 shadow-none p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-heading font-medium">Currency-wise Outstanding</div>
          <Button variant="outline" size="sm" data-testid="export-currency-csv"
            onClick={() => download("currency-outstanding.csv",
              [["Currency", "Invoiced", "Received", "Outstanding"],
               ...cur.map((c) => [c.currency, c.invoiced, c.received, c.outstanding])])}>
            Export CSV
          </Button>
        </div>
        <table className="data-table w-full">
          <thead><tr><th>Currency</th><th>Invoiced</th><th>Received</th><th>Outstanding</th></tr></thead>
          <tbody>
            {cur.map((c) => (
              <tr key={c.currency}>
                <td className="font-medium">{c.currency}</td>
                <td>{formatCurrency(c.invoiced, c.currency)}</td>
                <td className="text-emerald-700">{formatCurrency(c.received, c.currency)}</td>
                <td className="text-amber-700">{formatCurrency(c.outstanding, c.currency)}</td>
              </tr>
            ))}
            {cur.length === 0 && <tr><td colSpan={4} className="text-center text-slate-500 py-6">No data.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
